/**
 * Framed print auto-select fix.
 *
 * Problem: on products with a "Frame" option plus other options (e.g. an
 * Image/edition number and a Size), the "Framed" edition only exists for
 * ONE specific combination of the other options. When a customer clicks
 * "Framed" without first picking the matching values, Shopify can't find a
 * real variant for the combination, so the theme silently keeps showing
 * the unframed photo (and unframed price) instead of erroring out.
 *
 * Fix: as soon as "Framed" is selected, immediately pick the correct
 * values for the other options too (same DOM update a customer would make
 * by hand), before the existing variant-picker logic reads the current
 * selection and requests the matching variant. This runs in the capture
 * phase so it always happens before Dawn's own change handler on
 * <variant-selects>.
 */
(function () {
  function getVariantsData(root) {
    var script = root.querySelector('script[data-all-variants]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  // Radio/option ids follow the pattern {{ section.id }}-{{ option.position }}-{{ index }}
  // Position is 1-based and matches Shopify's option1/option2/option3 slots.
  function getOptionPosition(el) {
    if (!el || !el.id) return null;
    var parts = el.id.split('-');
    if (parts.length < 2) return null;
    var pos = parseInt(parts[parts.length - 2], 10);
    return isNaN(pos) ? null : pos;
  }

  function currentSelections(root) {
    var selections = {};
    root.querySelectorAll('fieldset input[type="radio"]:checked').forEach(function (input) {
      var pos = getOptionPosition(input);
      if (pos) selections[pos] = input.value;
    });
    root.querySelectorAll('.product-form__input--dropdown select').forEach(function (select) {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      var pos = getOptionPosition(opt);
      if (pos) selections[pos] = opt.value;
    });
    return selections;
  }

  function findFrameOption(variants) {
    var keys = ['option1', 'option2', 'option3'];
    for (var i = 0; i < keys.length; i++) {
      if (variants.some(function (v) { return v[keys[i]] === 'Framed'; })) {
        return { key: keys[i], position: i + 1 };
      }
    }
    return null;
  }

  function applySelection(root, position, value) {
    var radios = root.querySelectorAll('fieldset input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var radio = radios[i];
      if (getOptionPosition(radio) === position && radio.value === value) {
        radio.checked = true;
        return;
      }
    }
    var selects = root.querySelectorAll('.product-form__input--dropdown select');
    for (var j = 0; j < selects.length; j++) {
      var select = selects[j];
      for (var k = 0; k < select.options.length; k++) {
        var opt = select.options[k];
        if (getOptionPosition(opt) === position && opt.value === value) {
          select.selectedIndex = k;
          return;
        }
      }
    }
  }

  function handleChangeCapture(event) {
    var root = event.currentTarget;
    var target = event.target;
    if (!target) return;
    var isRadio = target.matches && target.matches('input[type="radio"]');
    var isSelect = target.tagName === 'SELECT';
    if (!isRadio && !isSelect) return;

    var variants = getVariantsData(root);
    if (!variants || !variants.length) return;

    var frameOption = findFrameOption(variants);
    if (!frameOption) return;

    var changedEl = isSelect ? target.options[target.selectedIndex] : target;
    var changedPosition = getOptionPosition(changedEl);
    if (changedPosition !== frameOption.position) return;
    if (target.value !== 'Framed') return;

    var selections = currentSelections(root);
    selections[frameOption.position] = 'Framed';

    var optionKeys = ['option1', 'option2', 'option3'];
    var framedVariants = variants.filter(function (v) {
      return v[frameOption.key] === 'Framed';
    });
    if (!framedVariants.length) return;

    // Prefer a framed variant that already matches the customer's other
    // current selections; otherwise fall back to the first available one.
    var best =
      framedVariants.find(function (v) {
        return optionKeys.every(function (k, idx) {
          var pos = idx + 1;
          if (pos === frameOption.position) return true;
          var sel = selections[pos];
          return sel == null || v[k] === sel;
        });
      }) ||
      framedVariants.find(function (v) {
        return v.available;
      }) ||
      framedVariants[0];

    optionKeys.forEach(function (k, idx) {
      var pos = idx + 1;
      if (pos === frameOption.position) return;
      var desired = best[k];
      if (desired == null) return;
      if (selections[pos] === desired) return;
      applySelection(root, pos, desired);
    });
  }

  function bind(root) {
    if (root.__framedAutoSelectBound) return;
    root.__framedAutoSelectBound = true;
    // Capture phase so this runs before <variant-selects>' own bubble-phase
    // change handler reads the current selection state.
    root.addEventListener('change', handleChangeCapture, true);
  }

  function init(scope) {
    (scope || document).querySelectorAll('variant-selects').forEach(bind);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });
  document.addEventListener('product-info:loaded', function (event) {
    init(event.target || document);
  });
})();
